import { getStaticTypoPcMo, getTypo, getTypoPcMo, getTypoRaw } from './index.ts';

/* js든 ts든 이것을 import 해서 사용 */

/**
 * @deprecated 가능하면 font 함수를 사용하세요
 */
export const typo = getTypo;

/**
 * @deprecated 가능하면 font 함수를 사용하세요
 */
export const staticTypo = getTypoRaw;

/**
 * @deprecated 가능하면 font 함수를 사용하세요
 */
export const typoPcMo = getTypoPcMo;

/**
 * @deprecated 가능하면 font 함수를 사용하세요
 */
export const staticTypoPcMo = getStaticTypoPcMo;
